export function toNumberOrNull(value: unknown): number | null {
  return typeof value === 'number' ? value : null
}

export function toStringOrNull(value: unknown): string | null {
  return typeof value === 'string' ? value : null
}

export function toStringOrUndefined(value: unknown): string | undefined {
  return typeof value === 'string' ? value : undefined
}

export function toBooleanOrNull(value: unknown): boolean | null {
  return typeof value === 'boolean' ? value : null
}

/**
 * Перевірка коду відповіді: `statusCode` (ApiError / axios) або `status` (Fetch Response).
 */
export function isStatusCode(error: unknown, code: number): boolean {
  if (!error || typeof error !== 'object') return false
  const o = error as { statusCode?: unknown; status?: unknown }
  if (o.statusCode === code) return true
  return typeof o.status === 'number' && o.status === code
}
